<template>
  <div id="app" :class="{ 'admin-page': isAdminPage, 'white-page': isWhitePage }">
    <SiteHeader v-if="!isAdminPage" />
    <main>
      <router-view />
    </main>
    <SiteFooter v-if="!isAdminPage" />
  </div>
</template>

<script>
import SiteHeader from './components/layout/Header.vue'
import SiteFooter from './components/layout/Footer.vue'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

export default {
  name: 'App',
  components: {
    SiteHeader,
    SiteFooter
  },
  setup() {
    const route = useRoute()
    
    const isAdminPage = computed(() => {
      return route.path === '/admin' || route.path === '/dashboard' || route.path.startsWith('/user/')
    })

    const isWhitePage = computed(() => {
      return route.path === '/' || route.path === '/privacy' || route.path === '/terms'
    })

    return {
      isAdminPage,
      isWhitePage
    }
  }
}
</script>

<style>
:root {
  --primary-color: #128078;
  --primary-light: #1a9a8f;
  --primary-dark: #0e5f5a;
  --primary-lighter: #2db3a8;
  --primary-darker: #0a4a45;
  --accent-color: #16c79a;
  --accent-light: #1dd1a2;
  --accent-dark: #0f9b7a;
  --text-primary: #ffffff;
  --text-secondary: #e8f5f4;
  --text-muted: #b8d5d2;
  --background-primary: #0a2e2b;
  --background-secondary: #0f3a36;
  --background-light: #1a4a45;
  --success-color: #00b894;
  --warning-color: #fdcb6e;
  --error-color: #e17055;
  --border-color: rgba(18, 128, 120, 0.2);
  --shadow-color: rgba(0, 0, 0, 0.15);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

*::before,
*::after {
  box-sizing: border-box;
}

html {
  min-height: 100vh;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  min-height: 100vh;
  height: 100%;
  overflow-x: hidden;
}

html, body {
  height: 100%;
  overflow-x: hidden;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: linear-gradient(135deg, var(--background-primary) 0%, var(--background-secondary) 100%);
}

#app.admin-page {
  background: linear-gradient(135deg, var(--background-primary) 0%, var(--background-secondary) 100%) !important;
  background-attachment: fixed !important;
}

#app.white-page {
  background: white !important;
}

main {
  flex: 1;
}

#app.admin-page main {
  background: linear-gradient(135deg, var(--background-primary) 0%, var(--background-secondary) 100%) !important;
  background-attachment: fixed !important;
}

#app.admin-page body {
  color: var(--text-primary) !important;
}
</style>

